/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.create.modals.remove.controllers', [
  'ui.bootstrap'
])

.controller('PassesCreateModalsRemoveController', ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {

    $scope.passesCreateModalsRemove = {

      model: "Your spankin new application.passes.create.modals.remove view!",

      init: function() {},

      confirm: function () {
        $uibModalInstance.close(true);
      },

      cancel: function () {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.passesCreateModalsRemove.init();

}]);